<template>
    <header class="page-header">
        <div class="top">
            <a class="logo" href="/" title="DropTicket">
                <img src="/images/common/logo.svg" alt="DropTicket">
            </a>
            <a class="button is-rounded is-small" href="https://manage.dropticket.it/" target="_blank">Accesso aziende</a>
        </div>

        <nav id="nav-header">
            <div class="items">
                <div class="item">
                    <a href="/it/chi-siamo">Chi siamo</a>
                </div>
                <div class="item">
                    <a class="submenu-parent"
                       :class="{'open-servizi': isServiceMenuOpen}"
                       @click="isServiceMenuOpen = !isServiceMenuOpen"
                       href="#">
                        Servizi
                    </a>
                </div>
                <div class="item is-submenu" :class="{'open-servizi': isServiceMenuOpen}">
                    <a  v-for="link in servicesLinks"
                        :key="link.url"
                        :href="link.url"
                        :class="{'is-active': (link.url.substring(1) === path)}">
                        {{ link.label }}
                    </a>
                </div>
                <div class="item"><a href="/it/vantaggi">Vantaggi</a></div>
                <div class="item"><a href="/it/business">Business</a></div>
                <div class="item"><a href="/it/promozioni">Promozioni in corso</a></div>

                <div class="item">
                    <a class="submenu-parent"
                       :class="{'open-profile': isProfileMenuOpen}"
                       @click="isProfileMenuOpen = !isProfileMenuOpen"
                       href="#">
                        Profilo
                    </a>
                </div>
                <div class="item is-submenu" :class="{'open-profile': isProfileMenuOpen}">
                    <a  v-for="link in profileLinks"
                        :key="link.url"
                        :href="link.url"
                        :class="{'is-active': (link.url.substring(1) === path)}">
                        {{ link.label }}
                    </a>
                </div>


                <div class="item"><a href="https://shop.dropticket.it/" target="_blank">Acquista Online</a></div>
                <div class="item"><a href="/it/news">News</a></div>
            </div>
        </nav>
    </header>
</template>

<script>

export default {

    name: "NavBar",

    data() {
        return {
            isServiceMenuOpen: false,
            isProfileMenuOpen: false,
            servicesLinks: [
                {
                    label: 'Sosta',
                    url: '/it/servizi/sosta'
                },
                {
                    label: 'Trasporti',
                    url: '/it/servizi/trasporti'
                },
            ],
            profileLinks: [
                {
                    label: 'Registrati',
                    url: '/it/registrati'
                },
                {
                    label: 'Connetti con DropPay',
                    url: '/it/dpconnect'
                },
            ]
        }
    },

    props: {
        path: {
            type: String
        }
    },

    mounted() {
        this.isServiceMenuOpen = (
            this.path === 'it/servizi/parchi-intrattenimento' ||
            this.path === 'it/servizi/sosta' ||
            this.path === 'it/servizi/trasporti'
        )
        this.isProfileMenuOpen = (
            this.path === 'it/registrati' ||
            this.path === 'it/dpconnect'
        )
    },

    watch: {
        isProfileMenuOpen: function (val) {
            if (val) {
                this.isServiceMenuOpen = false
            }
        },
        isServiceMenuOpen: function (val) {
            if (val) {
                this.isProfileMenuOpen = false
            }
        }
    }
}
</script>

<style scoped>
</style>
